import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper } from '@front-core/box';
import { HeadingXSmall } from '@front-core/typography';
import loadable from '@loadable/component';
import { useAppSelector } from '@shared/lib/hooks/useAppSelector';
import styles from './agentDealsStats.scss';
const AgentDealsStatsChart = loadable({
    resolved: {},
    chunkName() {
        return "components";
    },
    isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
            return !!__webpack_modules__[key];
        }
        return false;
    },
    importAsync: () => import(/* webpackChunkName: "components" */ './components'),
    requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve() {
        if (require.resolveWeak) {
            return require.resolveWeak("./components");
        }
        return eval('require.resolve')("./components");
    }
}, {
    ssr: false
});
const getDealsStatsCountForYear = (dealsStats) => dealsStats.reduce((result, dealsData) => {
    const { dealsCount } = dealsData;
    return result + dealsCount;
}, 0);
const AgentDealsStats = () => {
    const dealsStats = useAppSelector(state => { var _a; return (_a = state.agents) === null || _a === void 0 ? void 0 : _a.dealsStats; }) || [];
    const countDealsStats = getDealsStatsCountForYear(dealsStats || []);
    if (!(dealsStats === null || dealsStats === void 0 ? void 0 : dealsStats.length) || !countDealsStats) {
        return null;
    }
    return _jsxs(Paper, { tag: "section", className: styles.agentDealsStats, "data-sentry-element": "Paper", "data-sentry-component": "AgentDealsStats", "data-sentry-source-file": "index.tsx", children: [_jsx("div", { className: styles.header, children: _jsx(HeadingXSmall, { tag: "h2", wrapper: false, className: styles.title, "data-sentry-element": "HeadingXSmall", "data-sentry-source-file": "index.tsx", children: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0441\u0434\u0435\u043B\u043E\u043A \u0437\u0430 12 \u043C\u0435\u0441\u044F\u0446\u0435\u0432" }) }), _jsx(AgentDealsStatsChart, { "data-sentry-element": "AgentDealsStatsChart", "data-sentry-source-file": "index.tsx" })] });
};
export default AgentDealsStats;
